// Imports
import Panel from "./Panel.js"
import Stage  from "./Stage.js"
import { getDevice } from "./lib.js";
const isDebug = false;//ログ表示
const HINTMAX = 2;//ヒント利用最大数
const INCREASE_TIME = 120;//ヒントを押した際のタイマー増加
//暫定ステージ
const sample_stg = [
  [//10
    [2, 1, 5, 3, 1, 1],
    [2, 3, 1, 3, 3, 2],
    [6, 4, 3, 4, 2, 5],
    [2, 4, 2, 2, 1, 10],
    [1, 1, 2, 6, 1, 7],
    [3, 5, 1, 5, 3, 3]
  ],
  [//20
    [7, 5, 7, 6, 4, 3],
    [7, 5, 4, 6, 3, 2],
    [6, 3, 6, 3, 7, 5],
    [7, 4, 5, 4, 2, 1],
    [1, 5, 2, 3, 1, 3],
    [6, 7, 6, 5, 3, 6]
  ]
];
const sample_stg_a = [
  [//10
    [0, 0, 1, 1, 1, 1],
    [2, 0, 3, 3, 4, 4],
    [2, 0, 5, 3, 3, 4],
    [2, 5, 5, 6, 7, 8],
    [9, 5, 6, 6, 7, 10],
    [9, 9, 9, 7, 7, 10]
  ],
  [//20
    [0, 0, 1, 1, 1, 1],
    [2, 0, 3, 3, 4, 4],
    [2, 0, 5, 3, 3, 4],
    [2, 5, 5, 7, 7, 4],
    [6, 5, 7, 7, 7, 4],
    [6, 6, 6, 7, 7, 4]
  ]
];
class Myclass {
  constructor(fuga) {
    this.panel = fuga;
    this.selected = false;
  }
}
// State
export default class GameState extends Phaser.Scene {
  // Init
  constructor() {
    super({
      type: Phaser.AUTO,
      key: 'GameState',
      active: false,
    });
  }

  // Create
  create(config) {
    this.quitblockno = -1//
    this.firstTouch = true;//開始時にはパネルを選択できないように
   
    this.level = parseInt(config.level)
    //this.stage = new Stage(this.level);
    this.logicType = config.logic
    this.timer = 0;//秒単位の経過時間
    this.timeID = null;
    this.timeSprite = new Array();

    this.resetHistory();
    this.initPanel()
    this.initButton()
    this.initStart();
    //this.resetpanel()
    //this.initClearMenu()
    this.setClearMenu()
    this.initPauseMenu()
    this.initTimeSprite()
    this.initQuit()
    this.initHint()
    this.initHowto()
    
    this.input.on('pointerdown', (pointer) => {
        if(this.pauseMenu.visible)return;
        this.dragStart(pointer.x, pointer.y)
      
    });

    this.input.on('pointerup', (pointer) => {
      if(this.pauseMenu.visible)return;
      if(this.winText.visible)return;
      this.dragEnd(pointer.x, pointer.y)
    });

  }
  initPanel() {
    this.selectPanel = null
    this.panels = new Array()
    var index = 0;
    //var mode = Math.floor(Math.random() * 4);
    for (var i = 0; i < 6; i++) {
      for (var j = 0; j < 6; j++) {
        let panel = new Panel(this, GameConfig.panel_w, GameConfig.panel_w)
        panel.setDepth(1000).setPosition(i * GameConfig.panel_w + GameConfig.panel_start_x, j * (GameConfig.panel_w-1) + GameConfig.panel_start_y);
        /*
        switch (mode) {
          case 0:
            panel.setDepth(1000).setPosition(i * 90 + start_x, j * 90 + start_y);
            break;
          case 1:
            panel.setDepth(1000).setPosition((6 - i) * 90 + start_x, j * 90 + start_y);
            break;
          case 2:
            panel.setDepth(1000).setPosition(i * 90 + start_x, j * 90 + start_y);
            break;
          case 3:
            panel.setDepth(1000).setPosition((6 - i) * 90 + start_x, (6 - j) * 90 + start_y);
            break;
        }
        panel.setNumber(sample_stg[j][i])
        */
        panel.index = index++;
        this.panels.push(new Myclass(panel))
      }
    }
  }
  resetpanel(){
    this.clearTimer()
    this.setTimerProc()
    this.stage.createStage()
    //画面表示パネルの初期化
    this.panels.forEach((panel, index) => {
      panel.panel.avail = true
      
      panel.panel.setNumber(this.stage.grid.cells[index % 6][Math.floor(index / 6)])
  })
  this.hintArray2 = this.stage.hintArray2
  this.hintArray = this.stage.hintArray
}
//ステージ自動生成ができるまでの暫定
  resetpanel_old() {
    const sample_stg_a = [
      [//10
        [0, 0, 1, 1, 1, 1],
        [2, 0, 3, 3, 4, 4],
        [2, 0, 5, 3, 3, 4],
        [2, 5, 5, 6, 7, 8],
        [9, 5, 6, 6, 7, 10],
        [9, 9, 9, 7, 7, 10]
      ],
      [//20
        [0, 0, 1, 1, 1, 1],
        [2, 0, 3, 3, 4, 4],
        [2, 0, 5, 3, 3, 4],
        [2, 5, 5, 7, 7, 4],
        [6, 5, 7, 7, 7, 4],
        [6, 6, 6, 7, 7, 4]
      ]
    ];
    var mode = Math.floor(Math.random() * 4);
    this.mode = mode
    var sample_stg10 = this.level == 10 ? sample_stg[0] : sample_stg[1]
    this.panels.forEach((panel, index) => {
      panel.panel.avail = true
      switch (mode) {
        case 0:
          panel.panel.setNumber(sample_stg10[index % 6][Math.floor(index / 6)])
          break;
        case 1:
          panel.panel.setNumber(sample_stg10[index % 6][5 - Math.floor(index / 6)])
          break;
          case 2:
          panel.panel.setNumber(sample_stg10[5 - (index % 6)][Math.floor(index / 6)])
          break;
        case 3:
          panel.panel.setNumber(sample_stg10[5 - (index % 6)][5 - Math.floor(index / 6)])
          break;
      }
    });
    if (!this.hintArray2) {
      this.hintArray2 = new Array(this.level == 10 ? 11 : 7).fill().map(u => { return []; })
      //a = new Array(ARRAY_SIZE).fill().map(u => { return []; });
    }
    //this.hintArray2.fill({});
    //var id = 0;
    this.hintArray2.map((myObj, index) => { myObj.index = index; myObj.use = 0 })
    //this.hintArray2.forEach((myObj,index) => {myObj.index = id++;myObj.use = 0});

    //this.hintArray = Array.from(sample_stg_a[this.level == 10 ? 0 : 1]);
    this.hintArray = sample_stg_a[this.level == 10 ? 0 : 1].concat();
    var val1, val2;
    switch (mode) {
      case 0:
        break;
      case 2:
        for (var i = 0; i < 6; i++) {
          for (var j = 0; j < 3; j++) {
            val1 = this.hintArray[5 - j][i]
            val2 = this.hintArray[j][i]
            this.hintArray[5 - j][i] = val2
            this.hintArray[j][i] = val1
          }
        }
        break;
      case 1:
        for (var i = 0; i < 3; i++) {
          for (var j = 0; j < 6; j++) {
            val1 = this.hintArray[j][5 - i]
            val2 = this.hintArray[j][i]
            this.hintArray[j][5 - i] = val2
            this.hintArray[j][i] = val1
          }
        }
        break;
      case 3:
        for (var i = 0; i < 6; i++) {
          for (var j = 0; j < 3; j++) {
            val1 = this.hintArray[5 - j][i]
            val2 = this.hintArray[j][i]
            this.hintArray[5 - j][i] = val2
            this.hintArray[j][i] = val1
          }
        }
        for (var i = 0; i < 3; i++) {
          for (var j = 0; j < 6; j++) {
            val1 = this.hintArray[j][5 - i]
            val2 = this.hintArray[j][i]
            this.hintArray[j][5 - i] = val2
            this.hintArray[j][i] = val1
          }
        }
        break;
    }
    this.copyStage();
    
    this.stage.procStage(this.hintArray);
  }
  //ステージ作成に時間がかかることがあるのでその際にひょうじするもの
  initStart(){
    this.waitDisp = this.add.text(200,this.cameras.main.height/2, '◻️', { fontSize: '24px', fill: '#FFF' });
    setTimeout(()=>{
      this.stage = new Stage(this.level)
      this.waitDisp.setText('◻️ ◻️');
      setTimeout(()=>{
        this.waitDisp.setText('◻️ ◻️ ◻️');
        setTimeout(()=>{
          this.resetpanel()
          this.waitDisp.setVisible(false)
          //this.waitDisp.setText('◻️ ◻️ ◻️ ◻️');
        },5);
      },5)
    }
   ,5)
 /*
    var debugBack = this.add.graphics();
    debugBack.fillStyle(0xFFFFFF, 1);
    debugBack.fillRect(10,this.cameras.main.height/2, this.cameras.main.width-20, 18);
*/
  }
  //ヒントを使用した場合、透過したtime_plus_back.pngを画面一番下の中央に表示し、その上にtime_plus.pngを置きます
  initHint(){
    this.hintCount = 0;//ヒント利用数
    this.hintMenu = new Phaser.GameObjects.Container(this,0,0);
    var cleamenu1  =  new Phaser.GameObjects.Sprite(this,this.cameras.main.width/2,this.cameras.main.height - 20);

    cleamenu1.setTexture('img_time_plus_back');
    this.hintMenu.add(cleamenu1);
    cleamenu1  =  new Phaser.GameObjects.Sprite(this,this.cameras.main.width/2,this.cameras.main.height - 20);

    cleamenu1.setTexture('img_time_plus');
    this.hintMenu.add(cleamenu1);

    this.hintMenu.setDepth(1000);
    this.add.existing(this.hintMenu);
    this.hintMenu.setVisible(false)
  }
  //タイトルからゲーム開始時のゲーム説明表示
  //タイトル画面で開始を押した後にmanual.pngが表示されるのは３回までにします。
  initHowto(){
  var sp = this.add.image(this.cameras.main.width/2,this.cameras.main.height/2, 'img_howto')
  sp.setSize(this.cameras.main.width,this.cameras.main.height);
  sp.setDepth(10000)
  sp.setInteractive()
  sp.on('pointerdown', (pointer, localX, localY, event) => { 
    //(215,545)-(330,578) 552,620
    var _x = (this.cameras.main.width*215)/552
    var _y = (this.cameras.main.height*545)/620
    var _w = (this.cameras.main.width*115)/552
    var _h = (this.cameras.main.height*33)/620
    if( _x < localX && (_x + _w) > localX
       &&  _y < localY && (_y + _h) > localY){
        sp.setVisible(false)
        this.clearTimer()
        setTimeout(()=>this.firstTouch = false,500)
      }
    event.stopPropagation();
  });

  this.howto = sp;
  var cnt = localStorage.getItem("game4_cnt") | 0;
  if(cnt >= 3){//
    this.howto.setVisible(false)
    setTimeout(()=>this.firstTouch = false,500)

  }else{
    localStorage.setItem("game4_cnt", ++cnt);
  }
  }
  //ポーズ用のメニュー画面
 initPauseMenu(){
  this.pauseMenu = new Phaser.GameObjects.Container(this,this.cameras.main.width/2,this.cameras.main.height/2);
  var progressBox =  new Phaser.GameObjects.Graphics(this);
  progressBox.fillStyle(0x000000, 0.5);
  progressBox.fillRect(-this.cameras.main.width/2,-this.cameras.main.height/2, this.cameras.main.width,this.cameras.main.height);
  this.pauseMenu.setSize(this.cameras.main.width,this.cameras.main.height);
  this.pauseMenu.add(progressBox);
  this.pauseMenu.setDepth(1000);
  var cleamenu0  =  new Phaser.GameObjects.Sprite(this,0,0);
  cleamenu0.setTexture('img_btn_restart');
  this.pauseMenu.add(cleamenu0);

  var cleamenu1  =  new Phaser.GameObjects.Sprite(this,0,0);
  cleamenu1.setTexture('img_titlehe');
  cleamenu1.y = -50+10+55*4;
  this.pauseMenu.add(cleamenu1);

  this.add.existing(this.pauseMenu);

  cleamenu0.setInteractive();
  cleamenu0.on('pointerdown', () => {
    this.setTimerProc()
    this.soundPlay('se_decision3');
    //this.firstTouch = true;//中断再開時にはパネルを選択できないように
    this.pauseMenu.setVisible(false);
  });
  cleamenu1.setInteractive();
  cleamenu1.on('pointerdown', () => {
    
      this.soundPlay('se_decision3');
    
   // var result = window.confirm('サイトのトップ画面に移動します。よろしいですか？');
   // if(result){
   //   window.location.href = GameConfig.url;//"https://www.freegame-break.com/";
   // }
   this.clearInterval(this.timeID);
   this.scene.start('MenuState');
  });
  this.pauseMenu.setInteractive();
  this.pauseMenu.on('pointerdown', (pointer, localX, localY, event) => { 
    event.stopPropagation();
  });
  this.pauseMenu.setVisible(false);
}

//クリア画面の初期化
  setClearMenu(){
    this.winText = new Phaser.GameObjects.Container(this,this.cameras.main.width/2,this.cameras.main.height/2);
    this.add.existing(this.winText); 
    var cleamenu0  =  new Phaser.GameObjects.Sprite(this,0,0);
    cleamenu0.setTexture('img_clear_back');
    cleamenu0.setAlpha(0.6);
    cleamenu0.setScale(1.2);
    this.winText.add(cleamenu0);
  
    var winObj = new Phaser.GameObjects.Container(this,0,0);
    this.winText.add(winObj);
  
    cleamenu0  =  new Phaser.GameObjects.Sprite(this,0,0);
    cleamenu0.setTexture('img_clear');
    cleamenu0.y = -120+10-15-20;
    winObj.add(cleamenu0);
  
    cleamenu0  =  new Phaser.GameObjects.Sprite(this,0,0);
    cleamenu0.setTexture('img_treasure1');
    cleamenu0.setScale(0.3*1.5)
    cleamenu0.y = -120+10+55+20;
    winObj.add(cleamenu0);
    this.treasure0 = cleamenu0
    cleamenu0.setVisible(false)
    cleamenu0  =  new Phaser.GameObjects.Sprite(this,0,0);
    cleamenu0.setTexture('img_treasure2');
    cleamenu0.setScale(0.3*1.5)
    cleamenu0.y = -120+10+55+20;
    winObj.add(cleamenu0);
    this.treasure1 = cleamenu0
    //cleamenu0.setVisible(false)
    cleamenu0  =  new Phaser.GameObjects.Sprite(this,0,0);
    cleamenu0.setTexture('img_clear_time');
    cleamenu0.y = -120+10+55*2+25+10+15;
    winObj.add(cleamenu0);
    this.winText.timeSprite = new Array();
    var x = -20*2,y=-120+15+55*3+25;
    
    for(var i=0;i<4;i++){
      //var sprite = this.add.sprite(x, y, 'img_num');
      var sprite =  new Phaser.GameObjects.Sprite(this,0,0);
      sprite.setTexture('img_num').setPosition(x,y);
      
      if(i==1){
        //区切り　:
        x += 20;
        var sp =new Phaser.GameObjects.Sprite(this,0,0);
        sp.setTexture('img_num').setFrame(10).setPosition(x,y).setFrame(10);
        winObj.add(sp);
        //this.add.sprite(x, y, 'img_num').setFrame(10);
        x += 20;   
      }else{
        x  += 20;
      }
      sprite.setFrame(1);
      winObj.add(sprite);
      this.winText.timeSprite.push(sprite);
    }
   
    cleamenu0  =  new Phaser.GameObjects.Sprite(this,0,0);
    cleamenu0.setTexture('img_btn_ok');
    cleamenu0.y = -120+10+55*4+10+15;
    winObj.add(cleamenu0);
   
    cleamenu0.setInteractive();
    cleamenu0.on('pointerdown', () => { 
      
      this.soundPlay('se_decision3');
      winObj.setVisible(false)
      winObj2.setVisible(true)
     // clearInterval(this.timer);
     // this.scene.start('TitleState');
    });
  
  //２枚目
    var winObj2 = new Phaser.GameObjects.Container(this,0,0);
    this.winText.add(winObj2);
    winObj2.setVisible(false)
    // PC or SmartPhone
    var dev = getDevice();
    if (dev == "sp" || dev == "iPad") {
      cleamenu0 = new Phaser.GameObjects.Sprite(this, 0, 0);
      cleamenu0.setTexture("img_btn_replay");
      cleamenu0.y = -170 + 85 * 1;
      winObj2.add(cleamenu0);
      cleamenu0.setInteractive();
      cleamenu0.on('pointerdown', () => { 
        
        //this.soundPlay('se_decision3');
        
        this.restartGame();
        
      });
      cleamenu0 = new Phaser.GameObjects.Sprite(this, 0, 0);
      cleamenu0.setTexture("img_titlehe");
      cleamenu0.y = -170 + 85 * 2;
      winObj2.add(cleamenu0);
      cleamenu0.setInteractive();
      cleamenu0.on('pointerdown', () => { 
        
        this.soundPlay('se_decision3');
        
        clearInterval(this.timeID);
        this.scene.start('MenuState');
      });
      cleamenu0 = new Phaser.GameObjects.Sprite(this, 0, 0);
      cleamenu0.setTexture("img_btn_home");
      cleamenu0.y = -170 + 85 * 3;
      winObj2.add(cleamenu0);
      cleamenu0.setInteractive();
      cleamenu0.on('pointerdown', () => { 
        
        this.soundPlay('se_decision3');
        
        clearInterval(this.timeID);
        window.location.href = GameConfig.homeurl;//"https://www.freegame-break.com/";
  
      });
    } else {
      cleamenu0 = new Phaser.GameObjects.Sprite(this, 0, 0);
      cleamenu0.setTexture("img_btn_replay");
      cleamenu0.y = -130 + 85 * 1;
      winObj2.add(cleamenu0);
      cleamenu0.setInteractive();
      cleamenu0.on('pointerdown', () => { 
        
        this.soundPlay('se_decision3');
        
       
        this.restartGame();
        //this.firstTouch = false
      });
      cleamenu0 = new Phaser.GameObjects.Sprite(this, 0, 0);
      cleamenu0.setTexture("img_titlehe");
      cleamenu0.y = -130 + 85 * 2;
      winObj2.add(cleamenu0);
      cleamenu0.setInteractive();
      cleamenu0.on('pointerdown', () => { 
        
        this.soundPlay('se_decision3');
        
        clearInterval(this.timeID);
        this.scene.start('MenuState');
      });
    }
    this.winText.setDepth(1000);
    this.winText.setAlpha(0);
    this.winText.setVisible(false);
    this.winText.page1 = winObj
    this.winText.page2 = winObj2
  }
  initTimeSprite(){
     //時間表示用のスプライトの準備  
     this.add.sprite(GameConfig.timer_x, GameConfig.timer_y,'img_time').setScale(0.8);
   
     var x = GameConfig.timer_n_x,y=GameConfig.timer_n_y;
 
     for(var i=0;i<4;i++){
       var sprite = this.add.sprite(x, y, 'img_num');
       if(i==1){
         //区切り　:
         x += 20-1;
         this.add.sprite(x, y, 'img_num').setFrame(10);
         x += 20-1;   
       }else{
         x  += 20-1;
       }
       sprite.setFrame(0);
       this.timeSprite.push(sprite);
     } 
  }
  //降参表示
  initQuit() {
    this.quit = new Phaser.GameObjects.Container(this, this.cameras.main.width / 2, this.cameras.main.height / 2);
    this.add.existing(this.quit);
    var progressBox = new Phaser.GameObjects.Graphics(this);
    progressBox.fillStyle(0x000000, 0);
    progressBox.fillRect(-this.cameras.main.width / 2, -this.cameras.main.height / 2, this.cameras.main.width, this.cameras.main.height);
    this.quit.setSize(this.cameras.main.width, this.cameras.main.height);
    this.quit.add(progressBox);

    progressBox = new Phaser.GameObjects.Graphics(this);
    progressBox.fillStyle(0x000000, 0.5);
    progressBox.fillRect(-this.cameras.main.width / 2, -this.cameras.main.height / 2, this.cameras.main.width, GameConfig.panel_start_y);
   
    this.quit.add(progressBox);

    var graphics = new Phaser.GameObjects.Graphics(this);


    //let myRect = this.roundRect(50, 450, 400, 200, 20, 0xff0000)
    var graphics = this.add.graphics();
    graphics.fillStyle(0xffffff, 1);

    //  32px radius on the corners
    graphics.fillRoundedRect(GameConfig.gameWidth / 4, GameConfig.gameHeight / 3, 120, 60, 10);
    graphics.alpha = 0.5
    this.quit.add(graphics);



    var cleamenu2 = new Phaser.GameObjects.Text(this, GameConfig.gameWidth / 4 + 24 + 4, GameConfig.gameHeight / 3 + 6, 'OK', { fill: '#000', fontSize: '48px' });
    this.quit.add(cleamenu2);
    this.quit.setDepth(1000);

    /* cleamenu2.setInteractive();
    cleamenu2.on('pointerdown', () => {


      console.log("hint")
      this.resetPanels();
      this.quit.setVisible(false);

    }, this); */
    this.quit.setInteractive();
    this.quit.on('pointerdown', (pointer, localX, localY, event) => {
      if(426 < localX  && localX < 532 && 508 < localY  && localY < 560){
        this.panels.map(myObj => myObj.panel.emptyPanel()) //パネルを無地の矩形表示にする
        //this.resetPanels();
        if(isDebug){
          this.quit.setVisible(false);
        }else{
          setTimeout(()=>{
          this.quit.setVisible(false);
          this.restartGame()
          this.firstTouch = false
          },250)
        }
      }
      event.stopPropagation();
    });
    this.quit.setVisible(false);
  }
  initButton() {
    this.backBtn = this.add.sprite(GameConfig.button_undo_x, GameConfig.button_undo_y, 'img_back').setScale(0.6);
    //Undo Button
    this.backBtn.setInteractive();
    this.backBtn.on('pointerdown', () => {
      if(this.winText.visible)return;
      this.consolelog("undo")
      this.panels.map(myObj => myObj.selected = false) //パネルを非選択状態に戻す
      var array = this.backHistory()
      if(array.length == 0)return //履歴がない
      this.soundPlay('se_undo')
      this.quitblockno = -1;
      var panel = this.panels[array[0].id].panel
      var chkid = this.hintArray[panel.index % 6][Math.floor(panel.index / 6)]
      
      var isBlock = true;
      
    
      array.map(myObj => {
        let panel = this.panels[myObj.id].panel
        if(isBlock && chkid != this.hintArray[panel.index % 6][Math.floor(panel.index / 6)]){
          isBlock = false
        }
        panel.avail = true
      }
      );
      if(isBlock){
        this.hintArray2[chkid].use = 0;//uncheck 
      }
    }, this);

    //Game Logic
    var soundflg = true;//localStorage.getItem("game4_logic");
    this.logic = soundflg | true
    //ヒント
    this.hintBtn = this.add.sprite(GameConfig.button_hint_x, GameConfig.button_hint_y, 'img_btn_hint').setScale(0.6);
  /*
    var debugBack = this.add.graphics();
    debugBack.fillStyle(0xFFFFFF, 1);
    debugBack.fillRect(GameConfig.button_hint_x, GameConfig.button_hint_y, 80, 18 + 10);
    this.hintBtn = this.add.text(GameConfig.button_hint_x, GameConfig.button_hint_y, 'HINT', { fontSize: '24px', fill: '#000' });
    */
    this.hintBtn.setInteractive();
    this.hintBtn.on('pointerdown', () => {
      if(this.winText.visible)return;
      if(this.hintCount < HINTMAX){
     
        const result = this.hintArray2.filter(item => item.use !== 1)
        this.consolelog("hint")
        this.dispHint(result)
        this.hintBtnNum.setFrame(HINTMAX - this.hintCount)
      this.soundPlay('se_decision3');
      }
    
    }, this);
    this.hintBtnNum = this.add.sprite(GameConfig.button_hint_x+25, GameConfig.button_hint_y, 'img_hnum').setScale(0.6);
    this.hintBtnNum.setFrame(2)
    //var num = new Phaser.GameObjects.Sprite(this, 0, 50);
    //num.setTexture('img_hnum');
    //this.hintBtn.add(num);
    //降参
    /*
    var debugBack = this.add.graphics();
    debugBack.fillStyle(0xFFFFFF, 1);
    debugBack.fillRect(GameConfig.gameWidth/2 + 60, GameConfig.button_hint_y, 80, 18 + 10);
  
    this.quitBtn = this.add.text(GameConfig.gameWidth/2 + 60, GameConfig.button_hint_y, '降参', { fontSize: '24px', fill: '#000' });
    */
    this.quitBtn = this.add.sprite(GameConfig.button_giveup_x, GameConfig.button_giveup_y, 'img_btn_giveup').setScale(0.6);
  
    this.quitBtn.setInteractive();
    this.quitBtn.on('pointerdown', () => {
      if(this.winText.visible)return;
      this.firstTouch = false;
      this.soundPlay('se_decision3');
      this.quit.setVisible(true);
      
      this.consolelog("quit")
        //パネルを戻す
      this.panels.map(myObj => {

        myObj.panel.avail = true
      });
      this.dispQuit(0)
      
    
    }, this);
  
    //TITLE
/*    
    var debugBack = this.add.graphics();
    debugBack.fillStyle(0xFFFFFF, 1);
    debugBack.fillRect(GameConfig.button_hint_x + 120 + 190, GameConfig.button_hint_y, 80, 18 + 10);

    var Btn = this.add.text(GameConfig.button_hint_x + 120 + 190, GameConfig.button_hint_y, 'TITLE', { fontSize: '24px', fill: '#000' });
    Btn.setInteractive();
    Btn.on('pointerdown', () => {
      console.log("title")
      clearInterval(this.timeID);
      this.scene.start('MenuState');
    }, this);*/
//Sound Button
var se_btn = this.add.sprite(GameConfig.button_x + GameConfig.button_space , GameConfig.button_y,'img_se_on').setScale(0.6);
this.se = true;
if(GameConfig.sound){
  se_btn.setTexture('img_se_on');
  this.se = true;
}else{
  se_btn.setTexture('img_se_off');
  this.se = false;
}
se_btn.setInteractive();
se_btn.on('pointerdown', () => { 
  if(this.se){
    this.se = false;
    GameConfig.sound = false;
  se_btn.setTexture('img_se_off');
  }else{
    this.se = true;
    GameConfig.sound = true;
    se_btn.setTexture('img_se_on');
  }

  
  this.soundPlay('se_decision3');
  
  localStorage.setItem("game4_opt", GameConfig.sound + "");
});
//中断　Stop Button
var stop_btn = this.add.sprite(GameConfig.button_x + GameConfig.button_space * 2, GameConfig.button_y,'img_stop').setScale(0.6);
stop_btn.setInteractive();
stop_btn.on('pointerdown', () => {
if(this.winText.visible)return;
this.soundPlay('se_decision3');
this.pauseMenu.setVisible(true); 
this.clearInterval(this.timeID);
});
var restart_btn = this.add.sprite(GameConfig.button_x + GameConfig.button_space * 3, GameConfig.button_y, 'img_restart').setScale(0.6);
    restart_btn.setInteractive();
    restart_btn.on('pointerdown', () => {
      if(this.winText.visible)return;
      this.consolelog('restart')
      this.restartGame()
      this.firstTouch = false
    });
  }
  dragStart(touchX, touchY) {
    // ...
    let panel
    if(this.winText.visible)return;//クリア表示中は無視する
    if(GameConfig.panel_start_y > touchY)return;//上部のボタンを押した際は無視する
    //this.firstTouch = false
    if (panel = this.getPanel(touchX, touchY)) {
      //this.selectPanel = panel
      this.panels.map(myObj => myObj.selected = false);
      //panel.selected = true;

      this.consolelog("start=" + panel.panel.number)
    }
  }
  dragEnd(touchX, touchY) {
    if(this.winText.visible)return;//クリア表示中は無視する
    if(this.waitDisp.visible)return;//ステージ作成中は無視する
    if(this.howto.visible)return;//マニュアル表示時は無視する
    if(GameConfig.panel_start_y > touchY)return;//上部のボタンを押した際は無視する
    if(this.quit.visible)return;//こうさん終了時は無視する
    this.firstTouch = false
    this.selectPanel = null;
    var sum = 0;
    var panels = new Array()
    this.panels.map(myObj => {
      if (myObj.selected) {
        sum += myObj.panel.number
        panels.push(myObj.panel)
      }
      myObj.panel.select = false
    });
    if (sum == this.level) {
      if(this.erasePanel(panels)){//既存の回答ブロックでけしたか？
      //console.log(panels[0].index)
      //check flag
        var chkid = this.hintArray[panels[0].index % 6][Math.floor(panels[0].index / 6)]
        this.consolelog(chkid)
        this.hintArray2[chkid].use = 1;//check
      }
      
      if (this.calcWin()){
        this.dispClear()
        //this.clearInterval(this.timeID)
        //this.winText.setVisible(true)
      }
    }
    this.consolelog("end=" + sum)
  }
  //
  restartGame(){
    this.firstTouch = true;//中断再開時にはパネルを選択できないように
    this.soundPlay('se_start')
    this.winText.setVisible(false)
    this.resetpanel();
    this.resetHistory();
    this.hintCount = 0
    this.hintBtnNum.setFrame(HINTMAX - this.hintCount)
  
  }
  //
  calcWin(){
    var retval = true;
    for (var x = 0; x < 6; x++) {
      for (var y = 0; y < 6; y++) {
        let panel = this.panels[x + y * 6]
        if (panel.panel.avail) {
          retval = false;
        }
      }
    }
  return retval
   /*  const result = this.hintArray2.filter(item => item.use !== 1)
    if (result.length == 0){
        return true
    }else{
      return false
    }  */
  }
  // Update
  update() {
    if(this.firstTouch){
      //this.firstTouch=false
      return;
    }
  　//if(this.pauseMenu.visible)return;
    if(this.waitDisp.visible)return;//ステージ作成中は無視する
    if(this.howto.visible)return;//マニュアル表示時は無視する
    //降参表示
    if (this.quit.visible && --this.quitTime < 0) {
      this.resetPanels();
      this.dispQuit(++this.quitblockno)
      return;
    }
    
    var pointer = this.input.activePointer;
    if (pointer.isDown && !this.pauseMenu.visible && !this.quit.visible) {
      var touchX = pointer.x;
      var touchY = pointer.y;
      let panel
      if (panel = this.getPanel(touchX, touchY)) {
        if(this.selectPanel){
          var ofst = Math.abs(panel.panel.index - this.selectPanel.panel.index)
        }else{
          var ofst = 1
        }
        if(!(ofst ==1 || ofst == 6))return
        if (this.logicType == 'typeB') {
          if (panel != this.selectPanel) {
            if (panel.selected) {
              if (this.selectPanel) {
                this.selectPanel.panel.select = false;//change panel color
                //this.selectPanel.selected = true
                this.selectPanel.selected = false
              }
            } else {
              panel.selected = true
              panel.panel.select = true;//change panel color
            }
            if(this.selectPanel)
            //console.log(panel.panel.number+","+Math.abs(panel.panel.index - this.selectPanel.panel.index))
            this.selectPanel = panel
          }
        }else{//type A
          panel.selected = true
          panel.panel.select = true;//change panel color
          this.selectPanel = panel
        }
      }
    }
  }
  getPanel(x, y) {
    let _panel;
    this.panels.forEach(panel => {
      if (panel.panel.avail && panel.panel.rect.contains(x, y)) {
        _panel = panel
        return true;
        //console.log(panel.number)
      }
    });

    return _panel;
  }
  resetPanels() {
    //パネルを戻す
    this.panels.map(myObj => {

      myObj.panel.select = false
    });
   
  }
  erasePanel(panels) {
    this.consolelog('erase')
    this.quitblockno = -1;
    //this.backBtn.setVisible(true)
    this.soundPlay('se_erase')
    var retval = true;
    var chkid = this.hintArray[panels[0].index % 6][Math.floor(panels[0].index / 6)]
    panels.forEach(panel => {
      let blockid = this.hintArray[panel.index % 6][Math.floor(panel.index / 6)]
      if(retval && chkid != blockid){//消すブロックが　既存の回答(hintArray内)かどうか判定
        retval = false
      }
      this.record(panel)
      panel.avail = false;
    });
    this.nextHistory()
    return retval
  }
  copyStage(){
    for(var x=0;x<6;x++)
    for(var y=0;y<6;y++){
      let panel = this.panels[x + y*6]
      if(panel.panel.avail){
        this.stage.grid.cells[x][y] = panel.panel.number
      }else{
        this.stage.grid.cells[x][y] = 0;
      }
    }
  }

  //dispClear
dispClear(){


  clearInterval(this.timeID);
  this.drawTime(this.winText.timeSprite);
  if(this.hintCount == 0){
    this.treasure0.setVisible(true)
    this.treasure1.setVisible(false)
  }else{
    this.treasure0.setVisible(false)
    this.treasure1.setVisible(true)
  }
  //this.win = true;
  
  //２週目のクリア時対策
  this.winText.setAlpha(0);
  this.winText.page1.setVisible(true);
  this.winText.page2.setVisible(false);
  this.winText.setVisible(true);
  //this.backBtn.setVisible(false)
  this.fcount = 0;
  var self = this;
  //this.winText.setAlpha(1.0);
  
  this.addTween(this.winText,500,{
    targets: this.winText,
    alpha: 1,
    //x:0,
    delay: 500,
    duration: 500,
    repeat: 0,
    onStart(){
     
        self.soundPlay('se_over');
      
    },
    onComplete() {
    
    },
    });  
}
  //降参表示
  dispQuit(no){
    if(!isDebug)
      this.clearInterval(this.timeID)
    this.quitTime = 60
    //const array = this.hintArray2.filter(item => item.use !== 1)
    var array = this.hintArray2
    this.copyStage() //消したパネルを０にしてstage.grid.cels配列を更新
    var isHit = false;
    let arrayid = no;//Math.floor(Math.random() * array.length)
    if (arrayid >= array.length) {
      arrayid = 0;
    }
    for (var i = 0; i < array.length; i++) {
      let blockid = array[arrayid].index
      this.consolelog("hint=" + blockid)
      //if(false){
      if (this.stage.isBlockEmpty(blockid)) {
        isHit = true;
        //this.timer += INCREASE_TIME //タイムが120秒増えます
        this.panels.forEach(panel => {

          var chkid = this.hintArray[panel.panel.index % 6][Math.floor(panel.panel.index / 6)]
          if (chkid == blockid) {
            //this.blinkBlock(panel)
            panel.panel.num.setVisible(false)
            panel.panel.rectgr3.setVisible(true)
          }
        });
        break;
      }
      //別のブロックを検索する
      arrayid++
      if (arrayid >= array.length) {
        arrayid = 0;
      }
    }
    if(isHit){
      this.quitblockno = arrayid;
    }
  }
//優先度１、ヒントを使ったとき、まだ消してないパネル上で、正解のブロックがあればそこを点滅させます。
//優先度２、ヒントを使ったとき、まだ消してないパネルと消したパネル上で、正解のブロックがあればそこを点滅させます。

  dispHint(array) {
    this.copyStage() //消したパネルを０にしてstage.grid.cels配列を更新
    if(this.dispHint2(array,true) == false){//まだだ消してないパネル上で、正解のブロックがあればそこを点滅
        if(this.dispHint2(array,false) == false){//まだ消してないパネルと消したパネル上で、正解のブロックがあればそこを点滅
          this.dispHint3()//消したパネル上で、正解のブロックがあればそこを点滅させます。
        }else{
          this.hintCount++
        }
    }else{
      this.hintCount++
    }
    /*
    var isHit = false;
    var arrayid;
    //ヒントボタンを最初に押した時は残りブロックからランダムに一つ選ぶ
    if(this.quitblockno == -1){
      arrayid = Math.floor(Math.random() * array.length)
    }else{
    //ヒントボタン２度連打した際には　１度目と重複しないブロックを選ぶ
      arrayid = this.quitblockno + 1
      if (arrayid >= array.length) {
        arrayid = 0;
      }
    }
    //すでにブロック内のパネルが一部消されていたら　別のブロックを探す
    for (var i = 0; i < array.length; i++) {
      let blockid = array[arrayid].index
      this.consolelog("hint=" + blockid)
      //if(false){
      if (this.stage.isBlockEmpty(blockid)) {
        isHit = true;
        this.timer += INCREASE_TIME //タイムが120秒増えます
        this.panels.forEach(panel => {

          var chkid = this.hintArray[panel.panel.index % 6][Math.floor(panel.panel.index / 6)]
          if (chkid == blockid) {
            this.hintMenu.setVisible(true)
            this.blinkBlock(panel)

          }
        });
        break;
      }
      //別のブロックを検索する
      arrayid++
      if (arrayid >= array.length) {
        arrayid = 0;
      }
    }

    //使えるブロックがない場合　再検索
    //if( i== array.length ){
    if (isHit == false) {
      this.stage.hit = false;
      this.dispHint2(array)
      this.quitblockno = -1;

    }else{
      this.quitblockno = arrayid;
    }
    */
  }
  /*
優先度２、ヒントを使ったとき、まだ消してないパネルと消したパネル上で、正解のブロックがあればそこを点滅させます。
*/
  dispHint2(array,mode){
 
    var isHit = false;
    var arrayid;
    //ヒントボタンを最初に押した時は残りブロックからランダムに一つ選ぶ
    if(this.quitblockno == -1){
      arrayid = Math.floor(Math.random() * array.length)
    }else{
    //ヒントボタン２度連打した際には　１度目と重複しないブロックを選ぶ
      arrayid = this.quitblockno + 1
      if (arrayid >= array.length) {
        arrayid = 0;
      }
    }
    //すでにブロック内のパネルが一部消されていたら　別のブロックを探す
    for (var i = 0; i < array.length; i++) {
      let blockid = array[arrayid].index
      this.consolelog("hint=" + blockid)
      //if(false){
      if (this.stage.isBlockEmpty(blockid) == mode) {
        isHit = true;
        this.timer += INCREASE_TIME //タイムが120秒増えます
        this.panels.forEach(panel => {

          var chkid = this.hintArray[panel.panel.index % 6][Math.floor(panel.panel.index / 6)]
          if (chkid == blockid) {
            this.hintMenu.setVisible(true)
            this.blinkBlock(panel)

          }
        });
        break;
      }
      //別のブロックを検索する
      arrayid++
      if (arrayid >= array.length) {
        arrayid = 0;
      }
    }
    //使えるブロックがない場合　再検索
    //if( i== array.length ){
    if (isHit == false) {
      this.stage.hit = false;
      //this.dispHint2(array)
      this.quitblockno = -1;

    }else{
      this.quitblockno = arrayid;
    }
    return isHit

  }
/*
優先度３、ヒントを使ったとき、消したパネル上で、正解のブロックがあればそこを点滅させます。
*/
  dispHint3(){

  }
//現在の残りパネルから正解のブロックを検索し最初にヒットしたブロックをヒントとして表示する
  _dispHint2(){
    //this.copyStage()
    //this.stage.dumpGrid();
    for(var x=0;x<6;x++){
      for(var y=0;y<6;y++){
      if(!this.stage.hit){
        this.stage.isStartBlock(x,y)
      }else{
        break
      }
    }
    if(this.stage.hit)break
  }
  if(this.stage.hit){
    this.hintMenu.setVisible(true)
      this.timer +=INCREASE_TIME //タイムが120秒増えます
      this.stage.hintHistory.forEach(value => {
        var panel = this.panels[value.y + value.x * 6]
        this.blinkBlock(panel)        
        //console.log("hit=" + JSON.stringify(value))
      });
    }
  }
  
  blinkBlock(panel){
    panel.panel.num.setVisible(false)
    panel.panel.rectgr3.setVisible(true)
    var self = this
    this.tweens.add(
      //this.addTween(panel.panel,0,{
      {
        targets: panel.panel,
        alpha: 0,
        //x:0,
        ease: 'Power2',
        delay: 0,
        duration: 300,
        repeat: 3,
        onStart() {
          self.consolelog("start")
        },
        onRepeatScope: panel.panel,
        onRepeat: function () {
          this.setAlpha(1.0);
          self.consolelog("repeat")
        },
        onCompleteScope: panel.panel,
        onComplete() {
          this.setAlpha(1.0);
          this.num.setVisible(true)
          if(this.avail){
            this.rectgr3.setVisible(false)
          }else{
            this.avail = false
          }
          self.hintMenu.setVisible(false)
          self.consolelog("complete")
        },
      });
  }
  //record history
  record(card) {
    var step = { "id": card.index }

    this.history[this.historyCnt].push(step);
    return step;
  }
  //next recrod
  nextHistory(mode) {
    var mods = mode | null;
    if (mods == 1) {
      this.history[++this.historyCnt] = [1];
    } else {
      this.history[++this.historyCnt] = [];
    }
  }
  //back record
  backHistory() {
    if (this.history.length > 1) {
      this.history.pop();
      --this.historyCnt;
      var array = this.history.pop();
      this.history.push([]);
      return array;
    } else {
      //this.backBtn.setVisible(false)
      return []
    }
  }
  resetHistory() {
    var array;
    if (this.history) {
      while (array = this.history.pop()) {
        while (array.pop());
      }
    }
    this.historyCnt = 0;
    this.history = [];
    this.history[0] = [];//initialize
  }

  /**
   * call a function when a delayed tween starts tweening?
 * @param {Phaser.Math.Easing} ease 
 * @param {Phaser.GameObjects.GameObject} object 
 * @return {Phaser.Tweens.Tween}
 */
  addTween(object, duration, parameters, ease = null) {
    parameters.targets = object;
    parameters.ease = ease;
    parameters.duration = duration;

    if (parameters.onStart && parameters.delay) {
      let startFunc = parameters.onStart;
      delete parameters.onStart;
      this.time.delayedCall(parameters.delay, startFunc);
    }

    return this.tweens.add(parameters);
  }

   //経過時間表示
   drawTime(timeSprite){
    if(isDebug)return
    var timeStr = (Math.floor(this.timer/60)%60 < 10 ? '0' : '') + Math.floor(this.timer/60)%60;
    timeStr = timeStr + (this.timer%60 < 10 ? '0' : '') + this.timer%60;
    for(var i=0;i<timeStr.length;i++){
      let num = timeStr.substring(i,i+1);
      timeSprite[i].setFrame(num);
    }

    //this.scoreText.setText(timeStr);
  }
  setTimerProc(){
    if(this.timeID){
      this.clearInterval(this.timeID)
    }
    this.timeID = setInterval(()=>{
      this.timer++
      this.drawTime(this.timeSprite);
      //this.calcWin();
    },1000)
  }
  clearTimer(){
    this.timer = 0;
    // if(this.timeID != 0){
    //   clearInterval(this.timeID);
    //   this.timeID = 0;
    //   this.timer = 0;
    // }
    this.drawTime(this.timeSprite);
  }
  clearInterval(time){
    clearInterval(time)
    this.timeID = null
  }
  //音を出す
  soundPlay(key){
    if(GameConfig.sound){
      this.consolelog(key)
      this.sound.play(key);
    }
  }
  //デバッグ用のログ表示
  consolelog(val) {
    if(GameConfig.debug){
       console.log(val)
    }
} 
}